angular.module('app', []).controller('appController', AppController);
AppController.$inject = ['$scope'];
function AppController($scope) {
    window._appController = $scope;

    require([
            "esri/core/urlUtils",
            "esri/Map",
            "esri/WebMap",
            "esri/layers/FeatureLayer",
            "esri/layers/TileLayer",
            "esri/layers/GraphicsLayer",
            "esri/views/MapView",
            "esri/geometry/Point",
            "esri/symbols/PictureMarkerSymbol",
            "esri/Graphic",
            "esri/geometry/Extent",
            "dojo/domReady!"
        ],
        function (urlUtils, Map, WebMap, FeatureLayer, TileLayer, GraphicsLayer, MapView, Point, PictureMarkerSymbol, Graphic, Extent) {
            //****************************************
            //  Map Functions
            //****************************************
            $scope.map = null;
            $scope.view = null;
            function initMap() {
                return new Promise((resolve, reject)=> {
                    $scope.map = new WebMap({
                        portalItem: {
                            //id: "ebc144bd13a1442abc689df85b210e71" //Brian's Map
                            id: "68f4e9461f4941e3a794080fdecff6d3" //My Copy
                        }
                    });
                    $scope.view = new MapView({
                        container: "viewDiv",
                        map: $scope.map,
                        // zoom: 12
                    });

                    $scope.view.on('click', function (e) {
                        console.log(e.mapPoint.latitude + ' - ' + e.mapPoint.longitude);
                    });

                    waitForViewToLoad().then(()=> {
                        //_appController.map.allLayers._items[2].fullExtent
                        // var svcAreaLayer = _.find($scope.map.allLayers._items, {url : 'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer'});
                        $scope.view.extent = new Extent({
                            xmin: -9819007.122012226,
                            ymin: 5125390.701612146,
                            xmax: -9808124.82768971,
                            ymax: 5133163.768985371,
                            spatialReference: 3857
                        });
                        // $scope.view.extent = svcAreaLayer.fullExtent;
                        resolve();
                    });
                });
            }

            $scope.mapReady = false;
            function waitForViewToLoad() {
                return new Promise((resolve, reject)=> {
                    if ($scope.view.ready && $scope.view.allLayerViews.length >= 10) {
                        resolve();
                    } else {
                        setTimeout(()=> {
                            waitForViewToLoad().then(()=> {
                                $scope.mapReady = true;
                                $scope.$apply();
                                resolve();
                            });
                        }, 500);
                    }
                });
            }

            function clearWebMapLayers() {
                $scope.map.allLayers._items.forEach((layer)=> {
                    if (layer.url.indexOf('y9HoB5i6zoakT1FL') > -1) {
                        layer.visible = false;
                    }
                });
            }

            //****************************************
            //  Analytics
            //****************************************
            window.digitalData = {
                appData: {
                    WebAppName: 'webapp: operational adventure',
                    WebAppActivity: ''
                }
            };
            function trackEvent(eventDescription){
                window.digitalData.appData.WebAppActivity = eventDescription;
                _satellite.track('MUWAT');
                 console.log('Tracked: ' + eventDescription);
            }
            $scope.trackEvent = trackEvent;

            //****************************************
            //  Steps
            //****************************************
            $scope.steps = [
                {
                    title: 'Welcome to Naperville Utilities',

                    description: 'Your job as operations manager is to use your GIS to combine network data with operational information to optimize maintenance spending and prepare for the upcoming storm season. Based on your inputs in the following steps, you will have a direct impact on reliability and operational costs.',

                    layers: [
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/14",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/17",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/18",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer/0"
                    ],
                    advanceStepText: 'Let\'s Get Started'
                },
                {
                    title: 'Network Vulnerability',
                    description: 'The map contains data about factors that directly impact your vulnerability during a weather event. Use the slider bars below to set the level of importance of each factor.',
                    layers: [
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Vegetation_Outages/FeatureServer/0",
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Work_Order/FeatureServer/0",
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Trim_History/FeatureServer/0",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer/0"
                    ],
                    template: 'step2',
                    onLoad: ()=> {
                        initNetworkLayers();
                    },
                    advanceStepText: 'Calculate Risk'
                },
                {
                    title: 'Budget Allocation',
                    description: 'This heat map shows where you’re most at risk of an outage. Better act fast to get the repairs done before storm season starts! Use the sliders below to allocate your budget to where it\'s needed most. Act fast to ensure repairs are complete before storm season.',
                    layers: [
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Vegetation_Outages/FeatureServer/0",
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Work_Order/FeatureServer/0",
                        "https://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/Trim_History/FeatureServer/0"
                    ],
                    template: 'step3',
                    onLoad: ()=> {
                        loadHeatMapLayer();
                        drawServiceAreaLabels();
                        initServiceAreaLayers();
                    },
                    advanceStepText: 'Apply Budget'
                },
                {
                    title: 'Emergency Alert System',
                    description: 'The National Weather Service issued a severe thunderstorm warning. As the storm passed over Naperville, power outages may have occured. Click below to see if GIS helped you invest your time and money in the right service areas.',
                    layers: [
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/14",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/17",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/18",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer/0"
                    ],
                    template: 'step4',
                    onLoad: ()=> {

                    },
                    advanceStepText: 'View Outages'
                },
                {
                    title: 'Results',
                    description: '...',
                    layers: [
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/14",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/17",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NapervilleNetwork/FeatureServer/18",
                        "http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer/0"
                    ],
                    template: 'step5',
                    onLoad: ()=> {
                        loadOutageResults();
                        prepareResultsData();

                    },
                    advanceStepText: 'View Results'
                },
            ];

            $scope.activeStep = $scope.steps[0];
            $scope.loadStep = (stepNum)=> {
                $scope.activeStep = $scope.steps[stepNum];
                $scope.map.allLayers._items.forEach((layer)=> {
                    if (layer.url) {
                        var layerUrl = layer.url + '/' + (layer.layerId || 0);
                        layer.visible = ($scope.activeStep.layers.indexOf(layerUrl) > -1) || layer.url.indexOf('y9HoB5i6zoakT1FL') == -1;
                    }
                });
                if ($scope.activeStep.onLoad) {
                    $scope.activeStep.onLoad();
                }
            };

            $scope.loadNextStep = function () {
                var stepNum = $scope.steps.indexOf($scope.activeStep) + 1;

                trackEvent('Clicked Step ' + stepNum + ': ' + $scope.activeStep.advanceStepText);
                var i = $scope.steps.indexOf($scope.activeStep);
                $scope.loadStep(i + 1);
            };


            //********************************************
            // Step 2
            //********************************************
            $scope.networkLayerWeights = [{

                val: [0, 0, 0],
                label: ['Open Work Orders', 'Outage History', 'Tree-trimming History'],

                key: ['WorkOrder', 'VegetationOutages', 'TrimHistory'],
                colorClass: ['work-orders', 'vegetation-outages', 'trim-history'],
                layer: [],
                hideTotal: true
            }];

            function initNetworkLayers() {
                $scope.activeStep.layers.forEach((layer)=> {
                    layer = layer.replace('/0', '');
                    var key = layer.replace('_', '').split('/')[layer.split('/').length - 2];
                    var i = $scope.networkLayerWeights[0].key.indexOf(key);
                    if (i > -1) {
                        var mapLayer = _.find($scope.map.allLayers._items, {url: layer});
                        mapLayer.opacity = 0.25;
                        $scope.networkLayerWeights[0].layer[i] = mapLayer;
                    }
                });
            }

            $scope.updateNetworkLayerWeights = function () {
                $scope.networkLayerWeights[0].val.forEach((val, i)=> {
                    var weight = parseInt(val);
                    $scope.networkLayerWeights[0].val[i] = weight;

                    var mapLayer = $scope.networkLayerWeights[0].layer[i];
                    if (mapLayer) {
                        mapLayer.opacity = (0.75 * weight / 100) + 0.25;
                    }
                });
            };

            //********************************************
            // Step 3
            //********************************************

            var heatMaps = {
                VegetationOutages: 'https://tiles.arcgis.com/tiles/y9HoB5i6zoakT1FL/arcgis/rest/services/Vulnerability_Outages/MapServer',
                TrimHistory: 'https://tiles.arcgis.com/tiles/y9HoB5i6zoakT1FL/arcgis/rest/services/Vulnerability_Trimming/MapServer',
                WorkOrder: 'https://tiles.arcgis.com/tiles/y9HoB5i6zoakT1FL/arcgis/rest/services/Vulnerability_WO/MapServer',
                equal: 'https://tiles.arcgis.com/tiles/y9HoB5i6zoakT1FL/arcgis/rest/services/Vulnerability_Equal/MapServer'
            };

            function loadHeatMapLayer() {
                var heatMapLayerUrl = heatMaps.equal;

                var selectedWeights = _appController.networkLayerWeights[0];
                var maxWeight = _.max(selectedWeights.val);
                var minWeight = _.min(selectedWeights.val);
                if ((maxWeight - minWeight) > 3) {
                    var i = selectedWeights.val.indexOf(maxWeight);
                    var maxKey = selectedWeights.key[i];
                    heatMapLayerUrl = heatMaps[maxKey];
                }

                var heatMapLayer = new TileLayer({
                    url: heatMapLayerUrl,
                    opacity: 0.5
                });
                $scope.map.add(heatMapLayer);
            }

            var sectionLabels = [
                {img: 'nw-service-label.png', lat: 41.80389510536798, long: -88.18730374999852},
                {img: 'ne-service-label.png', lat: 41.812158603359094, long: -88.14465562499852},
                {img: 'sw-service-label.png', lat: 41.7585563699523, long: -88.20536621893739},
                {img: 'se-service-label.png', lat: 41.78103845479553, long: -88.12316187499852}
            ];

            function drawServiceAreaLabels() {
                $scope.sectionLabelsLayer = new GraphicsLayer();
                sectionLabels.forEach((sLabel)=> {
                    var sLabelSymbol = new PictureMarkerSymbol({
                        url: "./img/" + sLabel.img,
                        width: "116px",
                        height: "20px",
                        xoffset: "60px"
                    });
                    var sLabelPoint = new Point({
                        latitude: sLabel.lat,
                        longitude: sLabel.long,
                        spatialReference: {wkid: 102100}
                    });

                    var sLabelGraphic = new Graphic({
                        geometry: sLabelPoint,
                        symbol: sLabelSymbol
                    });
                    $scope.sectionLabelsLayer.graphics.add(sLabelGraphic);
                });
                $scope.map.add($scope.sectionLabelsLayer);
            }


            $scope.serviceAreaWeights = [{
                val: [0, 0, 0, 0],
                label: ['NW Service Area', 'NE Service Area', 'SW Service Area', 'SE Service Area'],
                key: ['ServiceArea1', 'ServiceArea2', 'ServiceArea3', 'ServiceArea4'],
                colorClass: ['service-area-1', 'service-area-2', 'service-area-3', 'service-area-4'],
                layerUrls: [
                    'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperService/FeatureServer/3',
                    'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperService/FeatureServer/2',
                    'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperService/FeatureServer/1',
                    'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperService/FeatureServer/0',
                ],
                layerOutlineIds: [
                    'NaperService_3641',    //NW
                    'NaperService_1485',    //NE
                    'NaperService_8866',    //SW
                    'NaperService_9064'    //SW
                ],
                layerFillIds: [
                    'NaperService_6057',    //NW
                    'NaperService_7425',    //NE
                    'NaperService_310',    //SW
                    'NaperService_555'    //SW
                ],
                hideTotal: true
            }];

            function initServiceAreaLayers() {
                $scope.serviceAreaWeights[0].layerFillIds.forEach((fillId)=> {
                    var fillLayer = _.find($scope.map.allLayers._items, {id: fillId});
                    fillLayer.visible = true;
                    fillLayer.opacity = 0;
                    $scope.map.allLayers.reorder(fillLayer, 2);
                });

                var serviceAreaLayer = _.find($scope.map.allLayers._items, {url: 'http://services3.arcgis.com/y9HoB5i6zoakT1FL/arcgis/rest/services/NaperServiceArea/FeatureServer'});
                $scope.map.allLayers.reorder(serviceAreaLayer, 7);
                serviceAreaLayer.visible = true;

                $scope.serviceAreaWeights[0].layerOutlines = [];
                $scope.serviceAreaWeights[0].layerOutlineIds.forEach((outlineId)=> {
                    var outlineLayer = _.find($scope.map.allLayers._items, {id: outlineId});
                    $scope.map.allLayers.reorder(outlineLayer, $scope.map.allLayers._items.length - 1);
                    $scope.serviceAreaWeights[0].layerOutlines.push(outlineLayer);
                });
            }

            var _highlightServiceArea = false;
            $scope.showHighlightOnServiceArea = function () {
                _highlightServiceArea = true;
            };
            $scope.updateServiceAreaWeights = function (itemIndex) {
                $scope.serviceAreaWeights[0].val.forEach((val, i)=> {
                    var weight = parseInt(val);
                    $scope.serviceAreaWeights[0].val[i] = weight;

                    var mapLayerId = $scope.serviceAreaWeights[0].layerFillIds[i];
                    if (mapLayerId) {
                        var fillLayer = _.find($scope.map.allLayers._items, {id: mapLayerId});
                        fillLayer.opacity = (0.50 * weight / 100);
                    }
                });
                $scope.serviceAreaWeights[0].layerOutlines.forEach((olLayer, i)=> {
                    olLayer.visible = (itemIndex == i && _highlightServiceArea);
                });
            };

            //********************************************
            // Step 4
            //********************************************
            var outages = [
                {
                    zone: 1,
                    pctToPrevent: 50,
                    customers: 900,
                    hours: 4,
                    point: new Point({
                        latitude: 41.79433141181751,
                        longitude: -88.15476108654305,
                        spatialReference: {wkid: 102100}
                    })//3600
                }, {
                    zone: 2,
                    pctToPrevent: 30,
                    customers: 400,
                    hours: 5,
                    point: new Point({
                        latitude: 41.7855379896379,
                        longitude: -88.14375785525598,
                        spatialReference: {wkid: 102100}
                    })//2000
                }, {
                    zone: 2,
                    pctToPrevent: 40,
                    customers: 800,
                    hours: 3.5,
                    point: new Point({
                        latitude: 41.79042509966443,
                        longitude: -88.13321970941102,
                        spatialReference: {wkid: 102100}
                    })//2800
                }, {
                    zone: 3,
                    pctToPrevent: 30,
                    customers: 250,
                    hours: 4.5,
                    point: new Point({
                        latitude: 41.77460533913897,
                        longitude: -88.16215562499849,
                        spatialReference: {wkid: 102100}
                    })//500
                }
            ];
            $('.pie-group').addClass('four-part');

            $scope.outageGraphics = [];
            $scope.outageHours = 0;
            $scope.customersAffected = 0;
            $scope.overtimeHours = 0;

            function loadOutageResults() {
                var outageHours = 0;
                var customersAffected = 0;
                var overtimeHours = 0;

                outages.forEach((outage, i)=> {
                    var sectorAllocation = parseInt($scope.serviceAreaWeights[0].val[outage.zone - 1]);
                    if (sectorAllocation < outage.pctToPrevent) {
                        outageHours += outage.hours * outage.customers;
                        customersAffected += outage.customers;
                        overtimeHours += outage.hours;

                        var outageGraphic = {
                            customers: outage.customers,
                            hours: outage.hours
                        };

                        positionAlertBox(true);
                        function positionAlertBox(inDigest) {
                            var screenPoint = $scope.view.toScreen(outage.point);
                            if (outageGraphic.x != screenPoint.x || outageGraphic.y != screenPoint.y) {
                                outageGraphic.x = screenPoint.x;
                                outageGraphic.y = screenPoint.y;
                                if (!inDigest) {
                                    $scope.$apply();
                                }
                            }
                            requestAnimationFrame(positionAlertBox);
                        }

                        $scope.outageGraphics.push(outageGraphic);
                        setTimeout(()=> {
                            outageGraphic.stage = 'visible';
                            $scope.$apply();
                            flashOutage(outageGraphic);
                        }, 1000 * i);

                        function flashOutage(outageGraphic) {
                            outageGraphic.stage = outageGraphic.stage == 'no-text' ? 'with-text' : 'no-text';
                            $scope.$apply();
                            if (!outageGraphic.clicked) {
                                setTimeout(()=> {
                                    flashOutage(outageGraphic);
                                }, 1000);
                            }
                        }
                    }
                });

                $scope.outageHours = outageHours;
                $scope.customersAffected = customersAffected;
                $scope.overtimeHours = overtimeHours;
            }

            $scope.viewOutageInfo = (outageGraphic)=> {
                outageGraphic.clicked = true;
                outageGraphic.showPopup = true;
                trackEvent('Outage Popup Clicked');
            };

            //********************************************
            // Step 5
            //********************************************
            function prepareResultsData() {

                $scope.networkLayerWeights[0].hideRange = true;
                $scope.networkLayerWeights[0].hideTotal = true;
                $scope.networkLayerWeights[0].showHighestValue = true;
                $scope.networkLayerWeights[0].showHighestValueLabel = true;
                $scope.networkLayerWeights[0].display = [80, 18, 12];

                $scope.serviceAreaWeights[0].hideRange = true;
                $scope.serviceAreaWeights[0].hideTotal = true;
                $scope.serviceAreaWeights[0].showHighestValue = true;
                $scope.serviceAreaWeights[0].showHighestValueLabel = true;
                $scope.serviceAreaWeights[0].display = [80];

                $scope.resultsData = [
                    $scope.networkLayerWeights[0],
                    $scope.serviceAreaWeights[0]
                ]
            }

            $scope.resultsModalVisible = false;
            $scope.showResultsPopup = function () {
                trackEvent('Clicked Step 5: View Results');
                $scope.resultsModalVisible = true;
            };

            //********************************************
            // Results Popup
            //********************************************
            $scope.reset = function () {
                trackEvent('Clicked Try Agian');

                $scope.networkLayerWeights[0].val = [0, 0, 0];
                $scope.serviceAreaWeights[0].val = [0, 0, 0, 0];
                $scope.outageGraphics = [];
                $scope.loadStep(0);
                $scope.resultsModalVisible = false;
            };

            //****************************************
            //  Steps
            //****************************************
            $scope.showCTA = function (buttonText) {
                trackEvent('Clicked ' + buttonText);
                if (window.parent) {
                    window.parent.postMessage('show-cta', '*');
                }
            };

            //********************************************
            // Init
            //********************************************
            initMap().then(()=> {
                clearWebMapLayers();
                $scope.loadStep(0);
                $scope.$apply();
            });

        }
    );
}

